export default "__VITE_ASSET__CP$CKyUH__"